import { createRoot, hydrateRoot } from "react-dom/client";
import "@fontsource-variable/plus-jakarta-sans";
import "@fontsource-variable/manrope";
import "@fontsource-variable/bricolage-grotesque";
import "@fontsource-variable/cormorant-garamond";
import { AppRoot } from "./AppRoot";
import { prepareCaptureMode } from "./renderReady";
import "./site.css";

const rootElement = document.getElementById("root")!;
const app = <AppRoot />;

prepareCaptureMode();

if (rootElement.dataset.prerendered === "true") {
  hydrateRoot(rootElement, app);
} else {
  createRoot(rootElement).render(app);
}
